import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaEmail = (): TabelaColuna => ({
  Chave: 'Email',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>E-mail</div>
})
